import { theme as defaultTheme } from "@mindlercare/ui-web";

// The backend passes `category.color` through verbatim as a free-form token.
// Map the agreed vocabulary to theme colors, defaulting unknown tokens to grey.
const DOT_COLORS: Record<string, string> = {
  blue: defaultTheme.COLORS.BLUE_MEDIUM,
  purple: defaultTheme.COLORS.PRIMARY_DARK,
  pink: defaultTheme.COLORS.PRIMARY_DARK,
  orange: defaultTheme.COLORS.SECONDARY,
  green: defaultTheme.COLORS.MEDIUM_GREEN,
  grey: defaultTheme.COLORS.GRAY,
  gray: defaultTheme.COLORS.GRAY,
};

export const dotColor = (token?: string): string =>
  (token && DOT_COLORS[token.toLowerCase()]) || defaultTheme.COLORS.GRAY;
